import React, {useEffect, useState} from 'react';
import {Button, DatePicker, DatePickerProps, Modal, Select, Space} from 'antd';
import 'dayjs/locale/ru';
import locale from 'antd/es/date-picker/locale/ru_RU';

type ModalProps = {
    visible: boolean;
    setVisible: Function;
    taskId?: string;
    getTaskByIdRequest: Function;
    updateTaskStatusRequest: Function;
}
export const ConfirmTaskCompleteModal = (props: ModalProps) => {
    const [date, setDate] = useState<string>('');
    const onChange: DatePickerProps['onChange'] = (date, dateString) => {
        setDate(dateString)
    };
    const updateStatusHandler = () => {
        if(date.length > 1) {
            const task: any = {
                taskId: props.taskId,
                status: 'completed',
                date,
            }
            props.updateTaskStatusRequest(task)
            setTimeout(() => {
                props.setVisible(false)
                return props.taskId && props.getTaskByIdRequest(props.taskId)
            }, 500)
        }
    }
    return (
        <Modal open={props.visible} onCancel={() => props.setVisible(false)} footer={[
            <Button type="primary" onClick={() => {updateStatusHandler()}}>
                Выполнить
            </Button>,
            <Button type="primary" onClick={() => {props.setVisible(false)}}>
                Назад
            </Button>
        ]} title="Уточните дату выполнения">
            <Space direction="vertical" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                {/*// @ts-ignore*/}
                <DatePicker locale={locale} style={{width: '300px'}} onChange={onChange} />
            </Space>
        </Modal>
    );
};